import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";

import { Footer } from "./components/layout/Footer";
import { Indicate } from "./pages/Indicate";
import { History } from "./pages/History";
import { Dashboard } from "./pages/Dashboard";
import { Header } from "./components/layout/Header";
import { Thanks } from "./pages/Thanks";

export function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-background text-foreground relative z-10">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/thanks/:indicatorEmail" element={<Thanks />} />
            <Route path="/:indicatorEmail" element={<Indicate />} />
            <Route path="/history" element={<History />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
